import React, { memo } from "react";
import PropTypes from "prop-types";
import useController from "./controller";
import { useTranslation } from "react-i18next";
import RadioGender from "../RadioGender";
import "./style.scss";

function RadioGenders({ onChange, formData, type, disabled, isGendersValid }) {
  const { refGenderList, isGenderDisabled } = useController();
  const { t } = useTranslation();
  RadioGenders.propTypes = {
    getValidGenders: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.string,
    type: PropTypes.oneOf(["edit", "register"]),
    gender: PropTypes.string,
    isGenderDisabled: PropTypes.bool,
    disabled: PropTypes.bool,
    isGendersValid: PropTypes.bool,
    formData: PropTypes.object,
  };
  const genders = [
    {
      id: "g-woman",
      name: "gender",
      checked: formData.gender === "female",
      value: "female",
      label: t("register_page.genders.woman"),
    },
    {
      id: "g-man",
      name: "gender",
      checked: formData.gender === "male",
      value: "male",
      label: t("register_page.genders.man"),
    },
  ];
  const cls = ["radio-variant__input-radio"];
  if (!isGendersValid && type === "register") {
    cls.push("radio-variant__input-radio_error");
  }
  return (
    <div className="radio-wrapper">
      {type === "register" && (
        <span className="radio-wrapper__invalid-genders">
          {!isGendersValid && t("login_page.invalid_genders")}
        </span>
      )}
      <div className="radio-wrapper__genders">
        {genders.map((variant, i) => {
          return (
            <RadioGender
              key={variant.id}
              variant={variant}
              onChange={onChange}
              // disabled={disabled || isGenderDisabled}
              disabled={disabled}
              cls={cls}
              refGenderList={refGenderList}
              currentIndex={i}
            />
          );
        })}
      </div>
    </div>
  );
}

export default memo(RadioGenders);
